import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon, ButtonGroup, Button, ButtonToolbar, Tooltip, OverlayTrigger } from "react-bootstrap";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import NumericInput from "../../../general/componentes/NumericInput";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import {
    fechaFinalConsulta,
    fechaInicialConsulta,
    tipoDocumentoEmpleador,
    documentoEmpleador,
    causal,
    excepcionado,
    estadoTrasladable,
    canalIngreso,
    tipoDocumentoProcesa,
    documentoProcesa
} from "../../config_general/modelo/TextosAyuda";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { Causal } from "../modelo/Causal";
import { TiposExcepcion } from "../modelo/TiposExcepcion";
import { FiltroEmpresasTraslado, GestionTraslado } from "../modelo/GestionEmpresasModelo";
import { Estado } from "../modelo/Estado";
import { RespuestaEmpresasTraslado } from "../modelo/GestionEmpresasModelo";
import TablaEmpresasTraslado from "./TablaEmpresasTraslado";
import { consultarEmpresasTraslado, descargarXLSEmpresasTraslado, gestionarEmpresasTraslado } from "../modulos/gestionEmpresaTrasladoActions";
import { CanalIngreso } from "../modelo/CanalIngreso";
import ModalDescargaPartesXLS from "../../config_general/componentes/ModalDescargaPartesXLS";
import { ModalGestionTraslado } from "./ModalGestionTraslado";
import * as moment from "moment";

class FiltroConsultaEmpresasTraslado extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            listaSeleccion: [],
            showModalGestion: false,
            estadoActualizar: undefined,
            mostrarModalDescarga: false
        };
    }

    componentWillMount() {

    }

    render() {
        const { datosRespuesta, estado, paginas, tamanoPagina, paginaActual, totalDatosConsulta } = this.props;

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Empresas Traslado</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta Empresas</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TextoAyuda texto={tipoDocumentoEmpleador} />
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <TextoAyuda texto={documentoEmpleador} />
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Inicial consulta</label>
                                                <TextoAyuda texto={fechaInicialConsulta} />
                                                <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()}/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final consulta</label>
                                                <TextoAyuda texto={fechaFinalConsulta} />
                                                <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()}/>
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="causal">Causal</label>
                                                <TextoAyuda texto={causal} />
                                                <TextoInputSelector name="causal" maestro={this.listaCausales()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="excepcionado">Excepcionado</label>
                                                <TextoAyuda texto={excepcionado} />
                                                <TextoInputSelector name="excepcionado" maestro={this.listaExcepciones()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="estado">Estado</label>
                                                <TextoAyuda texto={estadoTrasladable} />
                                                <TextoInputSelector name="estado" maestro={this.listaEstados()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="canalIngreso">Canal Ingreso</label>
                                                <TextoAyuda texto={canalIngreso} />
                                                <TextoInputSelector name="canalIngreso" maestro={this.listaCanalesIngreso()} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumentoProceso">Tipo Documento Proceso</label>
                                                <TextoAyuda texto={tipoDocumentoProcesa} />
                                                <TipoIdentificacion name="tipoDocumentoProceso" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documentoPorceso">Documento Proceso</label>
                                                <TextoAyuda texto={documentoProcesa} />
                                                <NumericInput name="documentoProceso" placeholder="Ingrese un documento" />
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {totalDatosConsulta > 0 &&
                                                        <a className="btns btn-success" onClick={this.mostrarModalDescarga}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.mostrarModalDescarga && this.renderModalXLS()}
                                                </Col>
                                                <Col smOffset={2} sm={4}>
                                                    {this.state.listaSeleccion.length > 0 && this.renderBotonGestionTraslado()}
                                                </Col>
                                                <Col smOffset={1} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderTablaRespuestasTSAT(datosRespuesta, estado, paginas, tamanoPagina, paginaActual)}
                    {this.state.showModalGestion && this.renderModalCambioEstado()}
                </Row>
            </div>
        );
    }

    renderBotonGestionTraslado() {
        const tooltipGestiones = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>Excepciónar:</strong> Se usa para marcar el estado del o de los registros en estado Excepción.
                    <br />
                    <strong>Negar:</strong> Se usa para marcar el estado del o de los registros en estado Negado.
                    <br />
                </span>
            </Tooltip>
        );
        return (
            <div className="button-group-form">
                <ButtonToolbar className="button-group-toolbar">
                    <ButtonGroup>
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => {
                                this.setState({ estadoActualizar: Estado[1] });
                                this.mostrarModalGestion();
                            }}>
                            <Glyphicon glyph="ok" /> &nbsp;Excepciónar
                        </Button>
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => {
                                this.setState({ estadoActualizar: Estado[2] });
                                this.mostrarModalGestion();
                            }}>
                            <Glyphicon glyph="remove" /> &nbsp;Negar
                        </Button>
                    </ButtonGroup>
                    <OverlayTrigger placement="top" overlay={tooltipGestiones}>
                        <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );
    }

    renderTablaRespuestasTSAT(datosRespuesta: Array<RespuestaEmpresasTraslado>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!datosRespuesta || !datosRespuesta.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado parámetros"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaEmpresasTraslado
                                respuestasTSAT={datosRespuesta}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                                ingresarConsecutivo={this.adicionarConsecutivo}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    renderModalCambioEstado = () => {
        return (
            <ModalGestionTraslado
                botonEnviar={this.state.estadoActualizar === Estado[2] ? "Negar" : "Excepciónar"}
                cantidadSeleccionados={this.state.listaSeleccion.length}
                cerrarModal={this.cerrarModalGestion}
                observacionGestion={this.obtenerObservacion}
            />
        );
    }

    obtenerObservacion = (observacion: string) => {
        this.actualizarEstado(observacion);
    };

    filtros(): FiltroEmpresasTraslado {
        return {
            dniEmpleador: this.state.dniEmpleador,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            causal: this.state.causal,
            excepcionado: this.state.excepcionado,
            estado: this.state.estado,
            canalIngreso: this.state.canalIngreso,
            dniProceso: this.state.dniProceso
        };
    }

    adicionarConsecutivo = (consecutivo: number) => {
        const lista = this.state.listaSeleccion;
        if (lista.includes(consecutivo)) {
            this.setState({ listaSeleccion: lista.filter((value) => value !== consecutivo) });
        } else {
            lista.push(consecutivo);
            this.setState({ listaSeleccion: lista });
        }
    };

    actualizarEstado = (observacion: string) => {
        const solicitud: GestionTraslado = {
            consecutivos: this.state.listaSeleccion,
            estado: this.state.estadoActualizar.codigoEstado,
            observacion: observacion,
            dniProceso: this.props.dniUsuarioGestionLogin
        };

        this.setState({ listaSeleccion: [] });
        this.cerrarModalGestion();
        this.props.dispatch(gestionarEmpresasTraslado(solicitud));
    };

    consultaPaginada = (filtro: FiltroEmpresasTraslado) => {
        this.props.dispatch(consultarEmpresasTraslado(filtro));
    };

    mostrarModalDescarga = () => {
        this.setState({ mostrarModalDescarga: true });
    };

    cerrarModalDescarga = () => {
        this.setState({ mostrarModalDescarga: false });
    };

    renderModalXLS = () => {
        const { totalDatosConsulta } = this.props;
        return (
            <ModalDescargaPartesXLS
                titulo={"Reporte Empresas Traslado"}
                totalRegistros={totalDatosConsulta}
                verModalXLS={this.state.mostrarModalDescarga}
                cantidadDescargaReporte={1000}
                closeModalXLS={this.cerrarModalDescarga}
                generarXLS={this.generarXLS}
            />
        );
    };

    generarXLS = (numeroReporte: number, cantidadRegistros: number) => {
        const filtro: FiltroEmpresasTraslado = {
            dniEmpleador: this.state.dniEmpleador,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            causal: this.state.causal,
            excepcionado: this.state.excepcionado,
            estado: this.state.estado,
            canalIngreso: this.state.canalIngreso,
            dniProceso: this.state.dniProceso,
            tamanoPagina: cantidadRegistros,
            paginaActual: numeroReporte
        };

        this.cerrarModalDescarga();
        this.props.dispatch(descargarXLSEmpresasTraslado(filtro));
    }

    onSubmit = (values: any) => {
        this.props.dispatch(consultarEmpresasTraslado(this.obtenerValores(values)));
    };

    obtenerValores = (values: any) => {

        const dniEmpleador = (values.tipoDocumento && values.documento) ? (values.tipoDocumento + values.documento) : undefined;
        const fechaInicial = values.fechaInicial ? values.fechaInicial.valueOf() : undefined;
        const fechaFinal = values.fechaFinal ? values.fechaFinal.valueOf() : undefined;
        const causal = values.causal ? values.causal.value : undefined;
        const excepcionado = values.excepcionado ? values.excepcionado.value : undefined;
        const estado = values.estado ? values.estado.value : undefined;
        const canalIngreso = values.canalIngreso ? values.canalIngreso.value : undefined;
        const dniProceso = (values.tipoDocumentoProceso && values.documentoProceso) ? (values.tipoDocumentoProceso + values.documentoProceso) : undefined;

        const filtro: FiltroEmpresasTraslado = {
            dniEmpleador: dniEmpleador,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            causal: causal,
            excepcionado: excepcionado,
            estado: estado,
            canalIngreso: canalIngreso,
            dniProceso: dniProceso,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            dniEmpleador: dniEmpleador,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            causal: causal,
            excepcionado: excepcionado,
            estado: estado,
            canalIngreso: canalIngreso,
            dniProceso: dniProceso,
            filtro: filtro
        });

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            tipoDocumento: undefined,
            documento: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined,
            tipoDocumentoProceso: undefined,
            documentoProceso: undefined
        };

        if (!values.fechaInicial && !values.fechaFinal)
            errors.fechaInicial = "Por favor seleccione una fecha como filtro para continuar";

        if (values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicial && values.fechaFinal)
            errors.fechaInicial = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicial && values.fechaFinal && (values.fechaInicial.isAfter(values.fechaFinal)))
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Por favor ingrese el numero del documento";

        if (!values.tipoDocumento && values.documento)
            errors.tipoDocumento = "Por favor seleccione una de las opciones";

        if (values.tipoDocumentoProceso && !values.documentoProceso)
            errors.documentoProceso = "Por favor ingrese el numero del documento";

        if (!values.tipoDocumentoProceso && values.documentoProceso)
            errors.tipoDocumentoProceso = "Por favor seleccione una de las opciones";

        return errors;
    };

    listaCausales = () => {
        return [].concat(
            Causal.map(value => ({
                value: value.codigoCausal,
                label: value.textoCausal
            })
            ));
    }

    listaExcepciones = () => {
        return [].concat(
            TiposExcepcion.map(value => ({
                value: value.codigoExcepcion,
                label: value.textoExcepcion
            })
            ));
    }

    listaEstados = () => {
        return [].concat(
            Estado.map(value => ({
                value: value.codigoEstado,
                label: value.nombreEstado
            })
            ));
    }

    listaCanalesIngreso = () => {
        return [].concat(
            CanalIngreso.map(value => ({
                value: value.codigoConsulta,
                label: value.texto
            })
            ));
    }

    cerrarModalGestion = () => {
        this.setState({ showModalGestion: false, estadoActualizar: undefined });
    }

    mostrarModalGestion = () => {
        this.setState({ showModalGestion: true });
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estado: R.pathOr([], ["gestion_empresas_traslado", "estado"])(store),
        estadoDescarga: R.pathOr([], ["gestion_empresas_traslado", "estadoDescarga"])(store),
        datosRespuesta: R.pathOr([], ["gestion_empresas_traslado", "datosRespuesta"])(store),
        paginas: R.pathOr([], ["gestion_empresas_traslado", "paginas"])(store),
        paginaActual: R.pathOr([], ["gestion_empresas_traslado", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["gestion_empresas_traslado", "tamanoPagina"])(store),
        totalDatosConsulta: R.pathOr([], ["gestion_empresas_traslado", "totalDatosConsulta"])(store)
    };
})(FiltroConsultaEmpresasTraslado);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/componentes/FiltroConsultaEmpresasTraslado.tsx